import { useEffect, useState } from "react";
import styles from "./loader.module.css";

type Props = {
  /**
   * Delay in milliseconds before showing the loader. Default is 200ms.
   */
  delay?: number;
};

export const Loader = ({ delay = 200 }: Props) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!showLoader) {
    return null;
  }

  return (
    <div className={styles.loaderContainer}>
      <svg
        className={styles.spinnerLogo}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 33 50"
        width="80"
        height="120"
        aria-label="Loading spinner"
      >
        <title>Loading spinner</title>
        <polygon
          className={`${styles.square} ${styles.square1}`}
          fill="#E6007D"
          points="24.5,37.2 24.5,33.1 20.5,33.1 20.5,37.2"
        />
        <polygon
          className={`${styles.square} ${styles.square2}`}
          fill="#E6007D"
          points="20.5,33.1 20.5,29 16.4,29 16.4,33.1"
        />
        <polygon
          className={`${styles.square} ${styles.square3}`}
          fill="#009B9B"
          points="20.5,45.2 20.5,37.1 12.4,37.1 12.4,45.2"
        />
        <polygon
          className={`${styles.square} ${styles.square4}`}
          fill="#0082C8"
          points="12.4,37.2 12.4,25 0.2,25 0.2,37.2"
        />
        <polygon
          className={`${styles.square} ${styles.square5}`}
          fill="#F5B400"
          points="32.6,25 32.6,4.8 12.4,4.8 12.4,25"
        />
      </svg>
      <p className={styles.loadingText}>Loading...</p>
    </div>
  );
};
